import { Controller } from '@hotwired/stimulus'

/** Controller for the organization selection step of the "create endorsements" flow.
 * Lets the user pick the parent organization and/or one or more affiliates, and
 * enables the submit button once at least one organization is selected. */
export default class extends Controller {
  static targets = ['checkbox', 'submit']

  connect() {
    this.updateSubmit()
  }

  updateSubmit() {
    this.submitTarget.disabled = !this.checkboxTargets.some(
      (checkbox) => checkbox.checked,
    )
  }
}
